// extracted by mini-css-extract-plugin
module.exports = {"component":"MentalHealthButton_component__imSVv","link":"MentalHealthButton_link__1Osxt","button":"MentalHealthButton_button__2gafS"};